module.exports = __webpack_public_path__ + "static/media/modalLabel--nameYourRecord.bf056a34.svg";